<header class="header" id="navbar">
  <mat-toolbar class="landing-header">
    <div class="container">
      <nav class="navbar navbar-expand-lg justify-content-between">
        <div class="sub-new d-flex align-items-center w-100">
          <button
            #toggleButton
            class="navbar-toggler example-icon"
            (click)="addClass()"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            mat-icon-button
            aria-label="Example icon-button with menu icon Toggle navigation"
          >
            <span class="mdi mdi-menu"></span>
          </button>
          <a class="navbar-brand" [routerLink]="['/home']">
            <img [src]="appConstant?.headerImgUrl" class="white-logo" />
            <img src="assets/images/logo-black.svg" class="black-logo" />
          </a>
          <div
            class="collapse navbar-collapse"
            id="navbarSupportedContent"
            [ngClass]="{ show: isShow }"
            *ngIf="true"
          >
            <div class="nav-overlay" (click)="closeMenu()"></div>
            <div class="nav-coll">
              <ul class="navbar-nav mr-auto top-menu" (click)="showPopup()">
                <li
                  class="nav-item"
                  *ngFor="let data of headerMenu?.header_menu; let i = index"
                >
                  <a
                    class="nav-link"
                    routerLinkActive="active"
                    [routerLink]="
                      data?.slug === 'home' ? ['/home'] : '/' + [data.slug]
                    "
                    [routerLinkActiveOptions]="{ exact: true }"
                    href="javascript:void(0)"
                    mat-flat-button
                    [ngClass]="{
                      active:
                        linkActive == data?.slug ||
                        (route.url == '/' && data?.slug === 'home')
                    }"
                  >
                    <span
                      class="sidebar-icon mdi mdi-shape-outline"
                      *ngIf="data?.slug === 'category'"
                    ></span>
                    <span
                      class="sidebar-icon mdi mdi-movie-settings-outline"
                      *ngIf="data?.slug === 'movies'"
                    ></span>
                    <span
                      class="sidebar-icon mdi mdi-movie-settings-outline"
                      *ngIf="data?.slug === 'videos'"
                    ></span>
                    <span
                      class="sidebar-icon mdi mdi-television"
                      *ngIf="data?.slug === 'tv_shows'"
                    ></span>
                    <span
                      class="sidebar-icon mdi mdi-television"
                      *ngIf="data?.slug === 'shows'"
                    ></span>
                    <span
                      class="sidebar-icon mdi mdi-playlist-music-outline"
                      *ngIf="data?.slug === 'music'"
                    ></span>
                    <span
                      class="sidebar-icon mdi mdi-television-classic"
                      *ngIf="data?.slug === 'live'"
                    ></span>
                    <span
                      class="sidebar-icon mdi mdi-podcast"
                      *ngIf="data?.slug === 'podcast'"
                    ></span>
                    <span
                      class="sidebar-icon mdi mdi-home-outline"
                      *ngIf="data?.slug === 'home'"
                    ></span>
                    <span class="menu-text">{{ data.menu | translate }}</span>
                  </a>
                </li>
                <!-- <li *ngIf="userInfo != null" class="nav-item">
                  <a [routerLink]="['/manage-profile']" class="nav-link" routerLinkActive="active"
                    href="javascript:void(0)" mat-flat-button><span
                      class="sidebar-icon mdi mdi-account-cog-outline"></span>
                    {{ "HEADER.MANAGE_PROFILE" | translate }}
                  </a>
                </li> -->
                <li *ngIf="userInfo != null" class="nav-item">
                  <a
                    [routerLink]="['/favorite']"
                    class="nav-link"
                    routerLinkActive="active"
                    href="javascript:void(0)"
                    mat-flat-button
                    ><span class="sidebar-icon mdi mdi-devices"></span>
                    <span class="menu-text">
                      {{ "HEADER.MYLIST" | translate }}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="collapse navbar-collapse"
            id="navbarSupportedContent"
            [ngClass]="{ show: isShow }"
            *ngIf="false"
          >
            <div class="nav-overlay" (click)="closeMenu()"></div>
            <div class="nav-coll">
              <ul class="navbar-nav mr-auto top-menu">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="javascript:void(0)"
                    [routerLink]="['/']"
                    [ngClass]="{ active: activeStatus == '/' }"
                    id="menu-home"
                    mat-flat-button
                  >
                    <span class="sidebar-icon mdi mdi-home-outline"></span>
                    <span class="menu-text">
                      Home
                    </span>
                  </a>
                </li>

                <li class="nav-item">
                  <a
                    class="nav-link"
                    [routerLink]="['/']"
                    [queryParams]="{ data: 'aboutus' }"
                    id="menu-about"
                    mat-flat-button
                    [ngClass]="{ active: activeStatus == 'aboutus' }"
                  >
                    <span
                      class="sidebar-icon mdi mdi-information-outline"
                    ></span>
                    <span class="menu-text">
                      About Us
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    [routerLink]="['/']"
                    [queryParams]="{ data: 'plan' }"
                    [ngClass]="{ active: activeStatus == 'plan' }"
                    id="menu-plan"
                    mat-flat-button
                  >
                    <span
                      class="sidebar-icon mdi mdi-book-account-outline"
                    ></span>
                    <span class="menu-text">
                      Plans
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    [routerLink]="['/']"
                    [queryParams]="{ data: 'series' }"
                    [ngClass]="{ active: activeStatus == 'series' }"
                    id="menu-courses"
                    mat-flat-button
                  >
                    <span class="sidebar-icon mdi mdi-video-outline"></span>
                    <span class="menu-text">
                      Series
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="d-flex justify-content-end align-items-center user-btn">
            <div class="">
              <ul class="d-flex align-items-center text-white mb-0 p-0">
                <a
                  href="javascript:void(0)"
                  class="text-white d-flex align-items-center font-22 mr-3"
                  [routerLink]="['/results']"
                >
                  <span class="icon-search"></span>
                </a>
                <!-- <div class="language">
                  <span
                    (click)="changeLanguage('en')"
                    matTooltip="English"
                    [ngClass]="{ active: this.language === 'en' }"
                  >
                    <img src="assets/images/english-flag.jpg" alt="..." />
                  </span>
                  <span
                    (click)="changeLanguage('es')"
                    matTooltip="Spanish"
                    [ngClass]="{ active: this.language === 'es' }"
                  >
                    <img src="assets/images/spanish-flag.png" alt="..." />
                  </span>
                </div> -->
                <!-- <div
                  class="language_selection desk-block"
                  (openedChange)="openSelect()"
                >
                  <mat-select
                    (selectionChange)="changeLanguage($event.value)"
                    [value]="language"
                  >
                    <mat-select-trigger>
                      <span *ngIf="language == 'en'">En</span>
                      <span *ngIf="language == 'es'">Es</span>
                    </mat-select-trigger>
                    <div class="language-select-option">
                      <mat-option
                        *ngFor="let language of translate.getLangs()"
                        [value]="language"
                      >
                        {{ language | titlecase }}
                      </mat-option>
                    </div>
                  </mat-select>
                </div> -->

                <!-- <a
                  href="javascript:void(0)"
                  class="text-white font-24 position-relative mr-3"
                >
                  <span class="mdi mdi-bell"></span>
                  <span class="batch">10</span>
                </a> -->
                <div class="dropdown" *ngIf="userInfo != null">
                  <div class="pro-menu" mat-icon-button>
                    <a
                      *ngIf="
                        userInfo?.people_profile[0]?.id == userInfo?.profile_id
                      "
                      class="circle min-profile d-block"
                      href="javascript:void(0)"
                    >
                      <img
                        src="{{ userInfo.image }}"
                        (error)="errorHandler($event)"
                      />
                    </a>
                    <span
                      *ngIf="
                        userInfo?.people_profile[0]?.id != userInfo?.profile_id
                      "
                      class="mr-0 add-user-icon icon-bg-{{
                        service?.profile?.color
                      }}"
                    >
                      <img src="assets/images/user-icon.png" class="w-100" />
                    </span>
                  </div>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <a
                      class="dropdown-item d-flex align-items-center mb-2"
                      href="javascript:void(0)"
                      *ngFor="
                        let data of userInfo.people_profile | slice: 0:3;
                        let i = index
                      "
                      (click)="
                        data.id != userInfo?.profile_id
                          ? changeProfile(data)
                          : ''
                      "
                    >
                      <span *ngIf="i === 0">
                        <span
                          *ngIf="userInfo.image"
                          class="circle min-profile d-block"
                        >
                          <img src="{{ userInfo.image }}" class="w-100"
                        /></span>

                        <span
                          *ngIf="!userInfo.image && data.color"
                          class="add-user-icon icon-bg-{{ data.color }}"
                        >
                          <img
                            src="assets/images/user-icon.png"
                            class="w-100"
                          />
                        </span>
                        <span
                          *ngIf="!userInfo.image && !data.color"
                          class="add-user-icon icon-bg-yellow"
                        >
                          <img
                            src="assets/images/user-icon.png"
                            class="w-100"
                          />
                        </span>
                      </span>
                      <span
                        *ngIf="i !== 0"
                        class="add-user-icon icon-bg-{{ data.color }}"
                      >
                        <img src="assets/images/user-icon.png" class="w-100" />
                      </span>
                      {{ data.name }}
                    </a>
                    <a
                      class="dropdown-item d-flex align-items-center"
                      [routerLink]="['/manage-profile/add']"
                    >
                      <span class="mdi mdi-plus add-user-icon"></span>
                      Add New
                    </a>
                    <a
                      class="dropdown-item d-flex align-items-center"
                      [routerLink]="['/manage-profile/watch']"
                    >
                      Manage Profile
                    </a>

                    <!-- <a *ngIf="userInfo.people_profile.length>3" [routerLink]="['/manage-profile/watch']">Learn More</a> -->
                    <hr />
                    <a
                      class="dropdown-item"
                      (click)="sidebarComponent.open()"
                      [routerLink]="['/my-account/profile']"
                      href="javascript:void(0)"
                    >
                      {{ "HEADER.MY_PROFILE" | translate }}</a
                    >
                    <a
                      class="dropdown-item"
                      [routerLink]="['/subscription']"
                      href="javascript:void(0)"
                    >
                      {{ "HEADER.PLANS" | translate }}</a
                    >
                    <!-- <a
                      class="dropdown-item d-flex justify-content-between"
                      (click)="themeChange()"
                      href="javascript:void(0)"
                    >
                      {{ "HEADER.THEME" | translate }}
                      <span class="icon-theme"></span>
                    </a> -->
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      (click)="logOut()"
                    >
                      {{ "SIDEBAR.LOGOUT" | translate }}
                    </a>
                  </div>
                </div>

                <div *ngIf="!userInfo || userInfo === null">
                  <a
                    [routerLink]="['/login']"
                    href="javascript:void(0)"
                    class="btn btn-theme"
                  >
                    {{ headerMenu?.sign_in | translate }}
                    <!-- <span class="d-none d-md-block" *ngIf="headerMenu?.sign_in"
                      >/</span
                    >
                    <span class="d-none d-md-block">{{
                      headerMenu?.sign_up | translate
                    }}</span> -->
                  </a>
                </div>
              </ul>
            </div>
          </div>
          <!-- <div class="language_selection mob-block mr-0">
            <mat-select
              (selectionChange)="changeLanguage($event.value)"
              [value]="language"
            >
              <mat-select-trigger>
                <span *ngIf="language == 'en'">En</span>
                <span *ngIf="language == 'es'">Es</span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let language of translate.getLangs()"
                [value]="language"
              >
                {{ language | titlecase }}
              </mat-option>
            </mat-select>
          </div> -->
        </div>
      </nav>
    </div>
  </mat-toolbar>
</header>
